<div class="loading">
  <i class="fa fa-spinner fa-spin fa-3x fa-fw" [style]="{'color': color}"></i>
</div>
